module.exports = __webpack_public_path__ + "img/arrowCircleIcon.105bc72b.png";